/*
 *   File : minor-pan-details.js
 *   Author URI : https://evoqins.com
 *   Description :  Component will allow the customer to submit PAN details.
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { parse, format } from 'date-fns';
import { Modal } from "bootstrap";


import { CustomFilePicker, CustomSelectBox, CustomTextInput, DatePicker, FilePreview, RadioGroup } from "../../../Component/Form-elements";
import { KYCSubmissionModal } from "../../../Component/Modal";
import { Icon } from "../../../Component/Icon";
import { GradientButton } from "../../../Component/CTA";

import APIService from "../../../Service/api-service";
import { _convertToLabelIdArray, _isFileTypeAllowed } from "../../../Helper";
import { _uploadDocumentToS3 } from "../../../Service/aws-service";
import Store from "../../../Store";


const MinorPANDetailsPage = (props) => {
    // max date that can be selected for dob (current date - 18 years)
    const maxDate = new Date();
    maxDate.setFullYear(maxDate.getFullYear() - 18);


    // Max: today (latest possible DOB)
    const maxDate1 = new Date();
    // Min: today - 18 years + 1 day
    const minDate = new Date(maxDate1.getFullYear() - 18, maxDate1.getMonth(), maxDate1.getDate() + 1);

    const PROGRESS_DATA = useSelector(state => state.generalData.KYC_PROGRESS_DATA);
    const GENERAL_DATA = useSelector(state => state.generalData.GENERAL_DATA);
    const GENERAL_TYPES = useSelector(state => state.generalData.KYC_GENERAL_DATA);


    const minorRef = useRef();
    const guardianRef = useRef();
    const detailsRef = useRef();

    const [panNumber, setPanNumber] = useState("");
    const [panNumberError, setPanNumberError] = useState("");
    const [dob, setDOB] = useState(null);
    const [dobError, setDobError] = useState("");
    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");
    const [uploadedPan, setUploadedPan] = useState(null);
    const [uploadedPanError, setUploadedPanError] = useState("");
    const [fileLoader, setFileLoader] = useState(false);
    const [genderData, setGenderData] = useState(_convertToLabelIdArray(GENERAL_DATA.gender) ?? []);
    const [relationData, setRelationData] = useState(_convertToLabelIdArray(GENERAL_DATA.nominee_guardian_relation) ?? []);
    const [addressProofOptions, setAddressProofOptions] = useState([]);
    const [dobProofOptions, setDobProofOptions] = useState([]);

    const [gender, setGender] = useState(genderData[0].id);
    const [panUrl, setPanUrl] = useState("");
    const [dobProof, setDobProof] = useState(null);
    const [dobProofError, setDobProofError] = useState("");
    const [documentProof, setDocumentProof] = useState(null);
    const [documentProofError, setDocumentProofError] = useState("");
    const [documentProofUrl, setDocumentProofUrl] = useState("");

    const [guardian, setGuardian] = useState(relationData[0].id);

    const [guardianPan, setGuardianPan] = useState("");
    const [guardianPanError, setGuardianPanError] = useState("");

    const [guardianDob, setGuardianDOB] = useState(null);
    const [guardianDobError, setGuardianDobError] = useState("");

    const [guardianName, setGuardianName] = useState("");
    const [guardianNameError, setGuardianNameError] = useState("");

    const [guardianPanProof, setGuardianPanProof] = useState(null);
    const [guardianPanProofError, setGuardianPanProofError] = useState("");
    const [guardianPanUrl, setGuardianPanUrl] = useState("");

    const [addressProof, setAddressProof] = useState(null);
    const [addressProofError, setAddressProofError] = useState("");

    const [addressProofDoc, setAddressProofDoc] = useState(null);
    const [addressProofDocError, setAddressProofDocError] = useState("");
    const [addressProofDocUrl, setAddressProofDocUrl] = useState("");

    const [signProof, setSignProof] = useState(null);
    const [signProofError, setSignProofError] = useState("");
    const [signProofUrl, setSignProofUrl] = useState("");

    const [addressLine1, setAddressLine1] = useState('');
    const [addressLine1Error, setAddressLine1Error] = useState('');

    const [addressLine2, setAddressLine2] = useState('');
    const [addressLine2Error, setAddressLine2Error] = useState('');

    const [addressCountry, setAddressCountry] = useState({ label: "India", value: 101 });
    const [addressCountryError, setAddressCountryError] = useState("");
    const [addressState, setAddressState] = useState(null);
    const [addressStateError, setAddressStateError] = useState("");
    const [addressCity, setAddressCity] = useState(null);
    const [addressCityError, setAddressCityError] = useState("");

    const [pinCode, setPinCode] = useState('');
    const [pinCodeError, setPinCodeError] = useState('');

    const [addressLine1p, setAddressLine1p] = useState('');
    const [addressLine1pError, setAddressLine1pError] = useState('');

    const [addressLine2p, setAddressLine2p] = useState('');
    const [addressLine2pError, setAddressLine2pError] = useState('');

    const [addressCountryP, setAddressCountryP] = useState({ label: "India", value: 101 });
    const [addressCountryPError, setAddressCountryPError] = useState("");
    const [addressStateP, setAddressStateP] = useState(null);
    const [addressStatePError, setAddressStatePError] = useState("");
    const [addressCityP, setAddressCityP] = useState(null);
    const [addressCityPError, setAddressCityPError] = useState("");

    const [pinCodeP, setPinCodeP] = useState('');
    const [pinCodePError, setPinCodePError] = useState('');

    const [isSameCurrent, setIsSameCurrent] = useState(true);

    const [kycCheck, setKycCheck] = useState(false);
    const [kycCheckBtn, setKycCheckBtn] = useState(false);

    const [countryOption, setCountryOptions] = useState([]);

    const [stateOption, setStateOptions] = useState([]);
    const [cityOption, setCityOptions] = useState([]);


    const [stateOption1, setStateOptions1] = useState([]);
    const [cityOption1, setCityOptions1] = useState([]);

    const [apiLoader, setApiLoader] = useState(false);
    const [kycCheckLoader, setKycCheckLoader] = useState(false);

    useEffect(() => {
        _getCountries();
    }, []);

    useEffect(() => {
        if (kycCheck === true) {
            const modal = new Modal(document.getElementById("kyc-submission"));
            modal.show();
        }
    }, [kycCheck]);

    useEffect(() => {
        if (isSameCurrent === true) {
            setAddressLine1p(addressLine1);
            setAddressLine2p(addressLine2);
            setAddressCountryP(addressCountry);
            setAddressStateP(addressState);
            setAddressCityP(addressCity);
            setPinCodeP(pinCode);
        } else {
            setAddressLine1p("");
            setAddressLine2p("");
            setAddressCountryP({ label: "India", value: 101 });
            setAddressStateP(null);
            setAddressCityP(null);
            setPinCodeP("");
            if (PROGRESS_DATA.address.permanent_address_country_id === null) {
                _getStates(101, 2);
            }
        }
    }, [isSameCurrent]);

    useEffect(() => {
        if (Object.keys(GENERAL_DATA).length > 0) {

            const address_proof = GENERAL_DATA.address_proof.length > 0 && GENERAL_DATA.address_proof.map((item) => {
                return ({
                    label: item.name,
                    value: item.id
                })
            })
            setAddressProofOptions(address_proof);

            const dob_proof = GENERAL_DATA.dob_proof.length > 0 && GENERAL_DATA.dob_proof.map((item) => {
                return ({
                    label: item.name,
                    value: item.id
                })
            })
            setDobProofOptions(dob_proof);
            // setSelectedAccountType(sub_types[0].id);
        }
    }, [GENERAL_DATA]);

    useEffect(() => {
        if (PROGRESS_DATA.minor_details.name_on_pan !== null) {
            setName(PROGRESS_DATA.minor_details.name_on_pan);
        }
        if (PROGRESS_DATA.minor_details.date_of_birth !== null) {
            const parsed_date = parse(PROGRESS_DATA.minor_details.date_of_birth, 'dd-MM-yyyy', new Date());
            const formatted_date = format(parsed_date, 'dd/MM/yyyy');
            setDOB(formatted_date);
        }
        if (PROGRESS_DATA.minor_details.minor_pan !== null) {
            setPanNumber(PROGRESS_DATA.minor_details.minor_pan);
        }
        if (PROGRESS_DATA.minor_details.minor_pan_proof !== null) {
            setPanUrl(PROGRESS_DATA.minor_details.minor_pan_proof)
            const decodedURL = decodeURIComponent(decodeURIComponent(PROGRESS_DATA.minor_details.minor_pan_proof));
            // Extract file name from URL
            const fileName = decodedURL.split('?')[0].split("/").pop();
            setUploadedPan(fileName)
        }
        if (PROGRESS_DATA.minor_details.gender_id !== null) {
            setGender(PROGRESS_DATA.minor_details.gender_id);
        }

        if (PROGRESS_DATA.minor_details.minor_dob_proof !== null) {
            setDobProof({ label: PROGRESS_DATA.minor_details.minor_dob_proof_text, value: PROGRESS_DATA.minor_details.minor_dob_proof_id });
        }

        if (PROGRESS_DATA.minor_details.minor_dob_proof !== null) {
            setDocumentProofUrl(PROGRESS_DATA.minor_details.minor_dob_proof)
            const decodedURL = decodeURIComponent(decodeURIComponent(PROGRESS_DATA.minor_details.minor_dob_proof));
            // Extract file name from URL
            const fileName = decodedURL.split('?')[0].split("/").pop();
            setDocumentProof(fileName)
        }

        if (PROGRESS_DATA.guardian_details.guardian_relation_id !== null) {
            setGuardian(PROGRESS_DATA.guardian_details.guardian_relation_id);
        }

        if (PROGRESS_DATA.guardian_details.guardian_name !== null) {
            setGuardianName(PROGRESS_DATA.guardian_details.guardian_name);
        }

        if (PROGRESS_DATA.guardian_details.guardian_dob !== null) {
            const parsed_date = parse(PROGRESS_DATA.guardian_details.guardian_dob, 'dd-MM-yyyy', new Date());
            const formatted_date = format(parsed_date, 'dd/MM/yyyy');
            setGuardianDOB(formatted_date);
        }

        if (PROGRESS_DATA.guardian_details.guardian_pan !== null) {
            setGuardianPan(PROGRESS_DATA.guardian_details.guardian_pan);
        }

        if (PROGRESS_DATA.guardian_details.guardian_pan !== null) {
            setGuardianPan(PROGRESS_DATA.guardian_details.guardian_pan);
        }

        if (PROGRESS_DATA.guardian_details.guardian_pan_proof !== null) {
            setGuardianPanUrl(PROGRESS_DATA.guardian_details.guardian_pan_proof)
            const decodedURL = decodeURIComponent(decodeURIComponent(PROGRESS_DATA.guardian_details.guardian_pan_proof));
            // Extract file name from URL
            const fileName = decodedURL.split('?')[0].split("/").pop();
            setGuardianPanProof(fileName)
        }

        if (PROGRESS_DATA.guardian_details.guardian_address_proof_id !== null) {
            setAddressProof({ label: PROGRESS_DATA.guardian_details.guardian_address_proof_text, value: PROGRESS_DATA.guardian_details.guardian_address_proof_id });
        }

        if (PROGRESS_DATA.guardian_details.guardian_address_proof !== null) {
            setAddressProofDocUrl(PROGRESS_DATA.guardian_details.guardian_address_proof)
            const decodedURL = decodeURIComponent(decodeURIComponent(PROGRESS_DATA.guardian_details.guardian_address_proof));
            // Extract file name from URL
            const fileName = decodedURL.split('?')[0].split("/").pop();
            setAddressProofDoc(fileName)
        }

        if (PROGRESS_DATA.guardian_details.guardian_signature !== null) {
            setSignProofUrl(PROGRESS_DATA.guardian_details.guardian_signature)
            const decodedURL = decodeURIComponent(decodeURIComponent(PROGRESS_DATA.guardian_details.guardian_signature));
            // Extract file name from URL
            const fileName = decodedURL.split('?')[0].split("/").pop();
            setSignProof(fileName)
        }

        if (PROGRESS_DATA.address.current_address_line_1 !== null) {
            setAddressLine1(PROGRESS_DATA.address.current_address_line_1);
        }
        if (PROGRESS_DATA.address.current_address_line_2 !== null) {
            setAddressLine2(PROGRESS_DATA.address.current_address_line_2);
        }
        if (PROGRESS_DATA.address.current_address_pincode !== null) {
            setPinCode(PROGRESS_DATA.address.current_address_pincode);
        }
        if (PROGRESS_DATA.address.current_address_country_id !== null) {
            setAddressCountry({ label: PROGRESS_DATA.address.current_address_country_name, value: PROGRESS_DATA.address.current_address_country_id });
            _getStates(PROGRESS_DATA.address.current_address_country_id, 1)
        }
        if (PROGRESS_DATA.address.current_address_state_id !== null) {
            setAddressState({ label: PROGRESS_DATA.address.current_address_state_name, value: PROGRESS_DATA.address.current_address_state_id });
            _getCities(PROGRESS_DATA.address.current_address_state_id, 1)
        }
        if (PROGRESS_DATA.address.current_address_city_id !== null) {
            setAddressCity({ label: PROGRESS_DATA.address.current_address_city_name, value: PROGRESS_DATA.address.current_address_city_id });
        }
        if (PROGRESS_DATA.address.same_as_correspondence !== null) {
            setIsSameCurrent(PROGRESS_DATA.address.same_as_correspondence);
        }
        if (PROGRESS_DATA.address.same_as_correspondence === false) {
            if (PROGRESS_DATA.address.permanent_address_line_1 !== null) {
                setAddressLine1p(PROGRESS_DATA.address.permanent_address_line_1);
            }
            if (PROGRESS_DATA.address.permanent_address_line_2 !== null) {
                setAddressLine2p(PROGRESS_DATA.address.permanent_address_line_2);
            }
            if (PROGRESS_DATA.address.permanent_address_pincode !== null) {
                setPinCodeP(PROGRESS_DATA.address.permanent_address_pincode);
            }
            if (PROGRESS_DATA.address.permanent_address_country_id !== null) {
                setAddressCountryP({ label: PROGRESS_DATA.address.permanent_address_country_name, value: PROGRESS_DATA.address.permanent_address_country_id });
                _getStates(PROGRESS_DATA.address.permanent_address_country_id, 2)
            }
            if (PROGRESS_DATA.address.permanent_address_state_id !== null) {
                setAddressStateP({ label: PROGRESS_DATA.address.permanent_address_state_name, value: PROGRESS_DATA.address.permanent_address_state_id });
                _getCities(PROGRESS_DATA.address.permanent_address_state_id, 2)
            }
            if (PROGRESS_DATA.address.permanent_address_city_id !== null) {
                setAddressCityP({ label: PROGRESS_DATA.address.permanent_address_city_name, value: PROGRESS_DATA.address.permanent_address_city_id });
            }
        }
    }, [PROGRESS_DATA]);

    const _handleInputFields = (type, value, file) => {
        switch (type) {
            case 1:
                setPanNumber(value);
                setPanNumberError("");
                break;
            case 2:
                setDOB(value);
                setDobError("");
                break;
            case 3:
                // eslint-disable-next-line
                let file_formatted = value.replace(/^.*[\\\/]/, '').split('/');
                file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
                const parts = file_formatted.split('.');
                if (parts.length > 1) {
                    const extension = '.' + parts.pop();
                    if (_isFileTypeAllowed(extension)) {
                        // checking if file size is greater than 5mb
                        const file_size = 5 * 1024 * 1024
                        if (file.size < file_size) {
                            _fileUpload(file_formatted, file, 1);
                        } else {
                            setUploadedPanError("File size should be less than 5mb");
                        }
                    }
                    else {
                        setUploadedPanError("File type should be .pdf, .jpeg, .jpg, .png");
                    }
                }
                break
            case 4:
                setName(value);
                setNameError("");
                break;
            case 5:
                setDobProof(value);
                setDobProofError("");
                break;
            case 6:
                setDocumentProofError("");
                // eslint-disable-next-line
                var file_formatted1 = value.replace(/^.*[\\\/]/, '').split('/');
                file_formatted1 = file_formatted1[0].replace(/[\(\)\s]/g, '');
                const parts1 = file_formatted1.split('.');
                if (parts1.length > 1) {
                    const extension = '.' + parts1.pop();
                    if (_isFileTypeAllowed(extension)) {
                        // checking if file size is greater than 5mb
                        const file_size = 5 * 1024 * 1024
                        if (file.size < file_size) {
                            _fileUpload(file_formatted1, file, 2);
                        } else {
                            setDocumentProofError("File size should be less than 5mb");
                        }
                    }
                    else {
                        setDocumentProofError("File type should be .pdf, .jpeg, .jpg, .png");
                    }
                }
                break;
        }
    }

    const _handleGuardianPanProof = (path, file) => {
        let file_formatted = path.replace(/^.*[\\\/]/, '').split('/');
        file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
        const parts = file_formatted.split('.');
        if (parts.length > 1) {
            const extension = '.' + parts.pop();
            if (_isFileTypeAllowed(extension)) {
                // checking if file size is greater than 5mb
                const file_size = 5 * 1024 * 1024
                if (file.size < file_size) {
                    setGuardianPanProofError("");
                    setFileLoader(3);
                    let url = "general/file-upload";
                    let body = {
                        "key": `support/${file_formatted}`
                    }

                    APIService(true, url, body).then((response) => {
                        if (response.status_code === 200) {
                            setFileLoader(3);

                            // s3 helper
                            _uploadDocumentToS3(response.data, file_formatted, file).then((result) => {
                                setGuardianPanUrl(response.data.view_info); // file got uploaded successfully
                                setGuardianPanProof(file_formatted);

                                setFileLoader(false);
                            }).catch(error => {
                                toast.dismiss();
                                toast.error(error, {
                                    type: "error",
                                });
                                setFileLoader(false);
                            });

                        } else {
                            setFileLoader(false);
                            toast.dismiss();
                            toast.error(response, {
                                type: "error",
                            });
                        }
                    })
                } else {
                    setGuardianPanProofError("File size should be less than 5mb");
                }
            }
            else {
                setGuardianPanProofError("File type should be .pdf, .jpeg, .jpg, .png");
            }
        }
    }

    const _handleGuardianAddressProof = (path, file) => {
        let file_formatted = path.replace(/^.*[\\\/]/, '').split('/');
        file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
        const parts = file_formatted.split('.');
        if (parts.length > 1) {
            const extension = '.' + parts.pop();
            if (_isFileTypeAllowed(extension)) {
                // checking if file size is greater than 5mb
                const file_size = 5 * 1024 * 1024
                if (file.size < file_size) {
                    setAddressProofDocError("");
                    setFileLoader(4);
                    let url = "general/file-upload";
                    let body = {
                        "key": `support/${file_formatted}`
                    }

                    APIService(true, url, body).then((response) => {
                        if (response.status_code === 200) {
                            setFileLoader(4);

                            // s3 helper
                            _uploadDocumentToS3(response.data, file_formatted, file).then((result) => {
                                setAddressProofDocUrl(response.data.view_info); // file got uploaded successfully
                                setAddressProofDoc(file_formatted);

                                setFileLoader(false);
                            }).catch(error => {
                                toast.dismiss();
                                toast.error(error, {
                                    type: "error",
                                });
                                setFileLoader(false);
                            });

                        } else {
                            setFileLoader(false);
                            toast.dismiss();
                            toast.error(response, {
                                type: "error",
                            });
                        }
                    })
                } else {
                    setAddressProofDocError("File size should be less than 5mb");
                }
            }
            else {
                setAddressProofDocError("File type should be .pdf, .jpeg, .jpg, .png");
            }
        }
    }

    const _handleSignProof = (path, file) => {
        let file_formatted = path.replace(/^.*[\\\/]/, '').split('/');
        file_formatted = file_formatted[0].replace(/[\(\)\s]/g, '');
        const parts = file_formatted.split('.');
        if (parts.length > 1) {
            const extension = '.' + parts.pop();
            if (_isFileTypeAllowed(extension)) {
                // checking if file size is greater than 5mb
                const file_size = 5 * 1024 * 1024
                if (file.size < file_size) {
                    setSignProofError("");
                    setFileLoader(5);
                    let url = "general/file-upload";
                    let body = {
                        "key": `support/${file_formatted}`
                    }

                    APIService(true, url, body).then((response) => {
                        if (response.status_code === 200) {
                            setFileLoader(5);

                            // s3 helper
                            _uploadDocumentToS3(response.data, file_formatted, file).then((result) => {
                                setSignProofUrl(response.data.view_info); // file got uploaded successfully
                                setSignProof(file_formatted);

                                setFileLoader(false);
                            }).catch(error => {
                                toast.dismiss();
                                toast.error(error, {
                                    type: "error",
                                });
                                setFileLoader(false);
                            });

                        } else {
                            setFileLoader(false);
                            toast.dismiss();
                            toast.error(response, {
                                type: "error",
                            });
                        }
                    })
                } else {
                    setSignProofError("File size should be less than 5mb");
                }
            }
            else {
                setSignProofError("File type should be .pdf, .jpeg, .jpg, .png");
            }
        }
    }

    // API - get countries
    const _getCountries = () => {
        const url = "general/countries";

        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                const countries = response.data.map((item) => {
                    return ({
                        label: item.name,
                        value: item.country_id
                    })
                })
                setCountryOptions(countries);
                if (PROGRESS_DATA.address.current_address_country_id === null) {
                    _getStates(101, 1);
                }
            }
        })
    }

    // API - get countries
    const _getStates = (id, type) => {
        const url = "general/states";

        const data = {
            "country_id": Number(id)
        }

        APIService(true, url, data).then((response) => {
            if (response.status_code === 200) {
                const states = response.data.map((item) => {
                    return ({
                        label: item.name,
                        value: item.state_id
                    })
                })

                if (type === 1) {
                    setStateOptions(states);
                } else {
                    setStateOptions1(states);
                }
            } else {
                if (type === 1) {
                    setStateOptions([]);
                } else {
                    setStateOptions1([]);
                }
            }
        })
    }

    // API - get cities
    const _getCities = (id, type) => {
        const url = "general/cities";

        const data = {
            "state_id": Number(id)
        }

        APIService(true, url, data).then((response) => {
            if (response.status_code === 200) {
                const cities = response.data.map((item) => {
                    return ({
                        label: item.name,
                        value: item.city_id
                    })
                })
                if (type === 1) {
                    setCityOptions(cities);
                } else {
                    setCityOptions1(cities);
                }

            } else {
                if (type === 1) {
                    setCityOptions([]);
                } else {
                    setCityOptions1([]);
                }

            }
        })
    }

    //API :: file upload api
    const _fileUpload = (key, file, type) => {
        setUploadedPanError("");
        setDocumentProofError("");
        setFileLoader(type);
        let url = "general/file-upload";
        let body = {
            "key": `support/${key}`
        }

        APIService(true, url, body).then((response) => {
            if (response.status_code === 200) {
                setFileLoader(type);

                // s3 helper
                _uploadDocumentToS3(response.data, key, file).then((result) => {
                    if (type === 1) {
                        setPanUrl(response.data.view_info); // file got uploaded successfully
                        setUploadedPan(key);
                    } else {
                        setDocumentProofUrl(response.data.view_info); // file got uploaded successfully
                        setDocumentProof(key);
                    }
                    setFileLoader(false);
                }).catch(error => {
                    toast.dismiss();
                    toast.error(error, {
                        type: "error",
                    });
                    setFileLoader(false);
                });

            } else {
                setFileLoader(false);
                toast.dismiss();
                toast.error(response, {
                    type: "error",
                });
            }
        })
    }

    const _addMinorDetails = () => {
        const url = "kyc/add-minor-details";
        setApiLoader(true);
        const request = {
            is_review: props.edit,
            minor_name: name,
            minor_dob: dob,
            minor_pan: panNumber,
            minor_pan_proof: panUrl,
            minor_dob_proof_id: dobProof.value,
            minor_dob_proof: documentProofUrl,
            minor_gender_id: gender,
            guardian_relation_id: guardian,
            guardian_name: guardianName,
            guardian_dob: guardianDob,
            guardian_pan: guardianPan,
            guardian_pan_proof: guardianPanUrl,
            guardian_address_proof_id: addressProof.value,
            guardian_address_proof: addressProofDocUrl,
            guardian_signature: signProofUrl,
            current_address_line_1: addressLine1,
            current_address_line_2: addressLine2,
            current_pincode: pinCode,
            current_city_id: addressCity.value,
            current_state_id: addressState.value,
            current_country_id: addressCountry.value,
            same_as_correspondent: isSameCurrent,
            permanent_address_line_1: addressLine1p,
            permanent_address_line_2: addressLine2p,
            permanent_pincode: pinCodeP,
            permanent_city_id: addressCityP?.value,
            permanent_state_id: addressStateP?.value,
            permanent_country_id: addressCountryP?.value,
        }

        APIService(true, url, request).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                Store.dispatch({
                    type: 'KYC_PROGRESS',
                    payload: response.kyc_data
                });
                if (response.data.kyc_check === true) {
                    setKycCheckBtn(true);
                } else {

                    props.updateProgress(response.kyc_data.is_review ? 5 : 3, props.text, props.is_manual)
                    toast.success("Minor details added successfully");

                }
            } else {
               toast.dismiss();
                toast.error(response.message);
            }
            setApiLoader(false);
        })
    }

    const _checkKyc = () => {
        const url = "kyc/kyc-check";
        setKycCheckLoader(true);

        APIService(false, url).then((response) => {
            if (response.status_code === 200) {
                  Store.dispatch({
                    type: 'KYC_PROGRESS',
                    payload: response.kyc_data
                });
                setKycCheck(true);
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
            setKycCheckLoader(false)
        })
    }

    function _validateForm() {
        let valid = true;
        if (guardianDob === null) {
            guardianRef.current.scrollIntoView({ block: "start" });

            setGuardianDobError("Enter Guardian's date of birth");
            valid = false;
        }
        if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(guardianPan.toLocaleUpperCase())) {
            guardianRef.current.scrollIntoView({ block: "start" });
            setGuardianPanError("Enter valid pan number");
            valid = false;
        }
        if (guardianName === "") {
            guardianRef.current.scrollIntoView({ block: "start" });
            setGuardianNameError("Please enter valid name");
            valid = false;
        }

        if (guardianPanUrl === "") {
            guardianRef.current.scrollIntoView({ block: "start" });
            setGuardianPanProofError("Please upload PAN");
            valid = false;
        }

        if (addressProof === null) {
            guardianRef.current.scrollIntoView({ block: "start" });
            setAddressProofError("Select Address proof type");
            valid = false;
        }

        if (addressProofDocUrl === "") {
            guardianRef.current.scrollIntoView({ block: "start" });
            setAddressProofDocError("Please upload Address proof");
            valid = false;
        }

        if (addressLine1.length === 0) {
            valid = false;
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            setAddressLine1Error('Address line1 is required');
        }
        if (addressLine2.length === 0) {
            valid = false;
            setAddressLine2Error('Address line2 is required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }

        if (addressCountry === null) {
            valid = false;
            setAddressCountryError('Country is required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (addressState === null) {
            valid = false;
            setAddressStateError('State is required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (addressCity === null) {
            valid = false;
            setAddressCityError('City is required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (pinCode.length === 0) {
            valid = false;
            setPinCodeError('Pin code in required');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (pinCode.length !== 0 && pinCode.length !== 6) {
            valid = false;
            setPinCodeError('Invalid pin code');
            detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
        }
        if (isSameCurrent === false) {
            if (addressLine1p.length === 0) {
                valid = false;
                detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
                setAddressLine1pError('Address line1 is required');
            }
            if (addressLine2p.length === 0) {
                valid = false;
                setAddressLine2pError('Address line2 is required');
                detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            }

            if (addressCountryP === null) {
                valid = false;
                setAddressCountryPError('Country is required');
                detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            }
            if (addressStateP === null) {
                valid = false;
                setAddressStatePError('State is required');
                detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            }
            if (addressCityP === null) {
                valid = false;
                setAddressCityPError('City is required');
                detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            }
            if (pinCodeP.length === 0) {
                valid = false;
                setPinCodePError('Pin code in required');
                detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            }
            if (pinCodeP.length !== 0 && pinCodeP.length !== 6) {
                valid = false;
                setPinCodePError('Invalid pin code');
                detailsRef.current.scrollIntoView({ block: "start", behavior: "smooth" });
            }
        }

        if (signProofUrl === "") {
            guardianRef.current.scrollIntoView({ block: "start" });
            setSignProofError("Please upload sign proof");
            valid = false;
        }

        if (dob === null) {
            minorRef.current.scrollIntoView({ block: "start" });
            setDobError("Enter date of birth");
            valid = false;
        }
        if (panNumber !== "" && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(panNumber.toLocaleUpperCase())) {
            minorRef.current.scrollIntoView({ block: "start" });
            setPanNumberError("Enter valid pan number");
            valid = false;
        }

        if (name === "") {
            minorRef.current.scrollIntoView({ block: "start" });
            setNameError("Please enter valid name");
            valid = false;
        }
        // if (panUrl === "") {
        //     setUploadedPanError("Please upload PAN");
        //     valid = false;
        // }

        if (dobProof === null) {
            minorRef.current.scrollIntoView({ block: "start" });
            setDobProofError("Please select DOB proof type");
            valid = false;
        }

        if (documentProofUrl === "") {
            minorRef.current.scrollIntoView({ block: "start" });
            setDocumentProofError("Upload Document proof type");
            valid = false;
        }
        if (valid === true) {
            _addMinorDetails();
        }

    }
    return (
        <div>
            <p className="color-black e-poppins e-poppins-bold e-font-24 mb-0" ref={minorRef}>Add details of minor </p>
            <p className="color-outer-space e-poppins-regular e-font-16 line-height-24px mb-0 pt-2" >Please enter the following personal details to proceed further.</p>
            <div className="row pt-4">
                <div className="col-md-4">
                    <CustomTextInput label="Minor name"
                        postfix="*"
                        value={name}
                        error={nameError}
                        handleChange={(value) => _handleInputFields(4, value)} />
                </div>
                <div className="col-md-4 pt-md-0 pt-4 mt-md-0 mt-2">
                    <DatePicker label={"Date of Birth"}
                        error={dobError}
                        value={dob}
                        isAdult={false}
                        maxDate={maxDate1}
                        minDate={minDate}
                        postFix="*"
                        dob={(value) => _handleInputFields(2, value)} />
                </div>
                <div className="col-md-4 pt-md-0 pt-4 mt-md-0 mt-2">
                    <CustomTextInput label="Minor PAN number"
                        pan={true}
                        value={panNumber}
                        maxLength={10}
                        inputClass="text-uppercase"
                        error={panNumberError}
                        handleChange={(value) => _handleInputFields(1, value)} />
                </div>

            </div>
            <div className="row">
                <div className="col-md-4 pt-4">
                    <h6 className="color-black e-font-12 e-poppins-medium mb-2">
                        Upload Minor PAN (optional)
                    </h6>
                    <CustomFilePicker accept=".png, .pdf, .jpeg "
                        className="e-select-file"
                        error={uploadedPanError}
                        loading={fileLoader === 1 ? true : false}
                        onSelectFile={(path, file) => {
                            _handleInputFields(3, path, file);
                        }} />
                    {
                        uploadedPan === null ?
                            null
                            :
                            <div className="col-12 pt-3">
                                <FilePreview fileName={uploadedPan}
                                    removeFile={() => setUploadedPan(null)} />
                            </div>
                    }
                </div>
            </div>
            <div className="row" ref={detailsRef}>
                <div className="col-md-4 pt-4">
                    <h6 className="color-black e-font-18 e-poppins-medium mb-3">
                        Gender
                    </h6>
                    <RadioGroup data={genderData}
                        id={gender}
                        radioHandler={(selected) => setGender(selected)} />
                </div>
            </div>
            <div className="row">
                <h6 className="color-black e-font-18 e-poppins-medium mb-3 pt-4">
                    Current Address
                </h6>
                <div className="col-lg-4 col-sm-6 col-12">
                    <CustomTextInput value={addressLine1}
                        label="Address 1"
                        postfix="*"
                        error={addressLine1Error}
                        handleChange={(e) => { setAddressLine1(e); setAddressLine1Error('') }} />
                </div>
                <div className="col-lg-4 col-sm-6 col-12 pt-sm-0 pt-4 mt-sm-0 mt-2">
                    <CustomTextInput value={addressLine2}
                        label="Address 2"
                        postfix="*"
                        error={addressLine2Error}
                        handleChange={(e) => { setAddressLine2(e); setAddressLine2Error('') }} />
                </div>


                <div className="col-lg-4 col-sm-6 col-12 pt-lg-0 pt-4 mt-lg-0 mt-2">
                    <CustomSelectBox value={addressCountry}
                        label="Country"
                        postfix="*"
                        isSearchable={true}
                        error={addressCountryError}
                        options={countryOption}
                        onInputChange={() => setAddressCountryError("")}
                        onSelectChange={(e) => {
                            setAddressCountry(e);
                            _getStates(e.value, 1);
                            setAddressState(null);
                            setAddressCity(null);
                            setAddressCountryError("");
                        }} />
                </div>

                <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-2">
                    <CustomSelectBox value={addressState}
                        label="State"
                        postfix="*"
                        error={addressStateError}
                        options={stateOption}
                        isSearchable={true}
                        isDisabled={addressCountry === null ? true : false}
                        onInputChange={() => setAddressStateError("")}
                        onSelectChange={(e) => {
                            setAddressState(e);
                            _getCities(e.value, 1);
                            setAddressCity(null);
                            setAddressStateError("");
                        }} />
                </div>
                <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-2">
                    <CustomSelectBox value={addressCity}
                        label="City"
                        postfix="*"
                        isDisabled={addressState === null ? true : false}
                        error={addressCityError}
                        options={cityOption}
                        isSearchable={true}
                        onInputChange={() => setAddressCityError("")}
                        onSelectChange={(e) => {
                            setAddressCity(e);
                            setAddressCityError("");
                        }} />
                </div>

                <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-2">
                    <CustomTextInput value={pinCode}
                        label="Pin code"
                        postfix="*"
                        type="number"
                        error={pinCodeError}
                        options={stateOption}
                        maxLength={6}
                        handleChange={(e) => {
                            setPinCode(e);
                            setPinCodeError('')
                        }} />
                </div>


            </div>

            <div className="row pt-4">
                <div className="col-12">
                    <div className="d-flex gap-2 color-black e-font-14 e-poppins-regular w-max">
                        <Icon icon={isSameCurrent == true ? "checked" : 'unchecked'}
                            size={24}
                            className="cursor-pointer"
                            onClick={() => setIsSameCurrent(!isSameCurrent)} />
                        Permanent address is same as current address
                    </div>
                </div>
            </div>
            {isSameCurrent === false && <div className="row">
                <h6 className="color-black e-font-18 e-poppins-medium mb-3 pt-4">
                    Permanent Address
                </h6>
                <div className="col-lg-4 col-sm-6 col-12">
                    <CustomTextInput value={addressLine1p}
                        label="Address 1"
                        id="Address1P"
                        postfix="*"
                        error={addressLine1pError}
                        handleChange={(e) => { setAddressLine1p(e); setAddressLine1pError('') }} />
                </div>
                <div className="col-lg-4 col-sm-6 col-12 pt-sm-0 pt-4 mt-sm-0 mt-2">
                    <CustomTextInput value={addressLine2p}
                        label="Address 2"
                        postfix="*"
                        id="Address2P"
                        error={addressLine2pError}
                        handleChange={(e) => { setAddressLine2p(e); setAddressLine2pError('') }} />
                </div>


                <div className="col-lg-4 col-sm-6 col-12 pt-lg-0 pt-4 mt-lg-0 mt-2">
                    <CustomSelectBox value={addressCountryP}
                        label="Country"
                        postfix="*"
                        isSearchable={true}
                        error={addressCountryPError}
                        options={countryOption}
                        onInputChange={() => setAddressCountryPError("")}
                        onSelectChange={(e) => {
                            setAddressCountryP(e);
                            _getStates(e.value, 2);
                            setAddressStateP(null);
                            setAddressCityP(null);
                            setAddressCountryPError("");
                        }} />
                </div>

                <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-2">
                    <CustomSelectBox value={addressStateP}
                        label="State"
                        postfix="*"
                        error={addressStatePError}
                        options={stateOption1}
                        isSearchable={true}
                        isDisabled={addressCountryP === null ? true : false}
                        onInputChange={() => setAddressStatePError("")}
                        onSelectChange={(e) => {
                            setAddressStateP(e);
                            _getCities(e.value, 2);
                            setAddressCityP(null);
                            setAddressStatePError("");
                        }} />
                </div>
                <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-2">
                    <CustomSelectBox value={addressCityP}
                        label="City"
                        postfix="*"
                        isDisabled={addressStateP === null ? true : false}
                        error={addressCityPError}
                        options={cityOption1}
                        isSearchable={true}
                        onInputChange={() => setAddressCityPError("")}
                        onSelectChange={(e) => {
                            setAddressCityP(e);
                            setAddressCityPError("");
                        }} />
                </div>

                <div className="col-lg-4 col-sm-6 col-12 mt-4 pt-2">
                    <CustomTextInput value={pinCodeP}
                        label="Pin code"
                        postfix="*"
                        type="number"
                        id="pinCodeP"
                        error={pinCodePError}
                        maxLength={6}
                        handleChange={(e) => {
                            setPinCodeP(e);
                            setPinCodePError('')
                        }} />
                </div>


            </div>}
            <div className="row">
                <div className="col-md-12 pt-4">
                    <h6 className="color-black e-font-18 e-poppins-medium mb-2">
                        Minor’s DOB proof
                    </h6>
                    <p className="color-outer-space e-poppins-regular e-font-16 line-height-24px mb-3">Please enter the following personal details to proceed further.</p>
                </div>
                <div className="col-md-4">
                    <CustomSelectBox value={dobProof}
                        label="Choose Document"
                        postfix="*"
                        error={dobProofError}
                        options={dobProofOptions}
                        onSelectChange={(input_value) => _handleInputFields(5, input_value)} />
                </div>
            </div>
            <div className="row">
                <div className="col-md-4 pt-4">
                    <h6 className="color-black e-font-12 e-poppins-medium mb-2">
                        Upload proof <span className='color-red'>
                            *
                        </span>
                    </h6>
                    <CustomFilePicker accept=".png, .pdf, .jpeg "
                        className="e-select-file"
                        error={documentProofError}
                        loading={fileLoader === 2 ? true : false}
                        onSelectFile={(path, file) => {
                            _handleInputFields(6, path, file);
                        }} />
                    {
                        documentProof === null ?
                            null
                            :
                            <div className="col-12 pt-3">
                                <FilePreview fileName={documentProof}
                                    removeFile={() => {
                                        setDocumentProof(null);
                                        setDocumentProofUrl("");
                                    }} />
                            </div>
                    }
                </div>
            </div>
            <p className="color-black e-poppins e-poppins-bold e-font-24 mb-2 margin-40px-top" ref={guardianRef}>Parent/Guardian details</p>
            <div className="row">
                <div className="col-md-12 pt-4">
                    <h6 className="color-black e-font-18 e-poppins-medium mb-3">
                        Relation with minor
                    </h6>
                    <RadioGroup data={relationData}
                        id={guardian}
                        radioHandler={(selected) => setGuardian(selected)} />
                </div>
            </div>
            <div className="row pt-4">
                <div className="col-md-4">
                    <CustomTextInput label="Guardian name as per PAN"
                        postfix="*"
                        value={guardianName}
                        error={guardianNameError}
                        handleChange={(value) => {
                            setGuardianName(value);
                            setGuardianNameError("");
                        }} />
                </div>
                <div className="col-md-4 pt-md-0 pt-4 mt-md-0 mt-2">
                    <DatePicker label={"Date of Birth"}
                        error={guardianDobError}
                        value={guardianDob}
                        isAdult={true}
                        maxDate={maxDate}
                        postFix="*"
                        dob={(value) => {
                            setGuardianDOB(value);
                            setGuardianDobError("");
                        }} />
                </div>
                <div className="col-md-4 pt-md-0 pt-4 mt-md-0 mt-2">
                    <CustomTextInput label="PAN number"
                        postfix="*"
                        pan={true}
                        value={guardianPan}
                        maxLength={10}
                        id="GuardianPan"
                        inputClass="text-uppercase"
                        error={guardianPanError}
                        handleChange={(value) => {
                            setGuardianPan(value);
                            setGuardianPanError("");
                        }} />
                </div>

            </div>
            <div className="row align-items-end">
                <div className="col-md-4 pt-4 pb-2">
                    <h6 className="color-black e-font-12 e-poppins-medium mb-2">
                        Upload PAN <span className='color-red'>*</span>
                    </h6>
                    <CustomFilePicker accept=".png, .pdf, .jpeg "
                        className="e-select-file"
                        error={guardianPanProofError}
                        loading={fileLoader === 3 ? true : false}
                        onSelectFile={(path, file) => {
                            _handleGuardianPanProof(path, file);
                        }} />
                    {
                        guardianPanProof === null ?
                            null
                            :
                            <div className="col-12 pt-3">
                                <FilePreview fileName={guardianPanProof}
                                    removeFile={() => {
                                        setGuardianPanProof(null);
                                        setGuardianPanUrl("");
                                    }} />
                            </div>
                    }
                </div>
                {/* {PROGRESS_DATA.guardian_details.guardian_pan !== null && <div className="col-2">
                    <span className="color-primary-color e-poppins-medium e-font-12 line-height-16px mb-0 text-decoration-underline cursor-pointer"
                        onClick={_checkKyc}>Check KYC now</span>
                    {kycCheckLoader === true && <img src={require('../../../Assets/Images/loader.gif')}
                        width={24}
                        height={24} />}
                </div>} */}
            </div>
            <div className="row pt-4 pb-2">
                <div className="col-md-4">
                    <CustomSelectBox value={addressProof}
                        label="Choose Document for Address Proof"
                        postfix="*"
                        error={addressProofError}
                        options={addressProofOptions}
                        onSelectChange={(input_value) => {
                            setAddressProof(input_value);
                            setAddressProofError("");
                        }} />
                </div>
            </div>
            <div className="row">
                <div className="col-md-4 pt-4">
                    <h6 className="color-black e-font-12 e-poppins-medium mb-2">
                        Upload address proof<span className='color-red'>*</span>
                    </h6>
                    <CustomFilePicker accept=".png, .pdf, .jpeg "
                        className="e-select-file"
                        error={addressProofDocError}
                        loading={fileLoader === 4 ? true : false}
                        onSelectFile={(path, file) => {
                            _handleGuardianAddressProof(path, file);
                        }} />
                    {
                        addressProofDoc === null ?
                            null
                            :
                            <div className="col-12 pt-3">
                                <FilePreview fileName={addressProofDoc}
                                    removeFile={() => {
                                        setAddressProofDoc(null);
                                        setAddressProofDocUrl("");
                                    }} />
                            </div>
                    }
                </div>
            </div>
            <div className="row">
                <div className="col-md-4 pt-4 pb-2">
                    <h6 className="color-black e-font-12 e-poppins-medium mb-2">
                        Upload signature<span className='color-red'>*</span>
                    </h6>
                    <CustomFilePicker accept=".png, .pdf, .jpeg "
                        className="e-select-file"
                        error={signProofError}
                        loading={fileLoader === 5 ? true : false}
                        onSelectFile={(path, file) => {
                            _handleSignProof(path, file);
                        }} />
                    {
                        signProof === null ?
                            null
                            :
                            <div className="col-12 pt-3">
                                <FilePreview fileName={signProof}
                                    removeFile={() => {
                                        setSignProof(null);
                                        setSignProofUrl("");
                                    }} />
                            </div>
                    }
                </div>
            </div>
            <div className="row">
                <div className="col-md-4 pt-4">
                    <p className="color-outer-space e-poppins-regular e-font-sm-16-14 line-height-24px border-radius-8px bg-beige w-fit-content p-3 mb-4">
                        Sign on a blank white paper using blue ink, take a clear photo of it and upload
                    </p>
                </div>
            </div>
            <GradientButton label={kycCheckBtn ? "Check KYC" : "Continue"}
                loading={kycCheckBtn ? kycCheckLoader : apiLoader}
                className="px-3 padding-12px-tb e-font-16 margin-40px-top-sm-16 mob-w-100"
                handleClick={() => kycCheckBtn ? _checkKyc() : _validateForm()} />
            {
                kycCheck === true && <KYCSubmissionModal
                    type={2}
                    continue={() => {
                        props.updateProgress(PROGRESS_DATA.is_review ? 5 : 3, props.text, props.is_manual);
                        setKycCheck(false)
                    }}
                    close={() => setKycCheck(false)} />
            }
        </div>
    )
}
export default MinorPANDetailsPage